import { Component, OnInit, Input } from '@angular/core';
import { AppService } from '../../shared/services/app.service';

@Component({
    selector: 'app-eula',
    templateUrl: './eula.component.html',
    styleUrls: ['./eula.component.scss'],
    standalone: false
})
export class EulaComponent implements OnInit {
  @Input() data:any = false;
  public _currentData:any = false;
  constructor(public appService:AppService) {
   
   }

  ngOnInit() {
    this._currentData = this.data;
    this._currentData.url = this._currentData.documentUri;
  }
  selectDoc(eula){
    this._currentData = eula;
    this._currentData.url = this._currentData.documentUri;
  }
  

}
